import React, { useContext, useEffect, useState } from "react";
import themeContext from "../../../context/theme/ThemeContext";

const BrowserCheck = ({ onBrowserDetect }) => {
  const { themeName } = useContext(themeContext);
  const [isChrome, setIsChrome] = useState(true);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isChromeBrowser = /chrome/.test(userAgent) && !/edge|edg|opera/.test(userAgent);
    setIsChrome(isChromeBrowser);
    if (onBrowserDetect) {
      onBrowserDetect(isChromeBrowser); // notify parent
    }
  }, []);

  return (
    <div style={{ position: "absolute", bottom: "70%", right: "12px", marginBottom: "2px", display: "flex", alignItems: "center", zIndex: 5 }}>
      {!isChrome && (
        <span
          style={{
            fontSize: "11px",
            fontWeight: 600,
            lineHeight: "16px",
            color: themeName === "light" ? "white" : "rgb(3, 52, 98)",
            background: "grey",
            padding: "2px 10px",
            borderRadius: "12px",
            whiteSpace: "nowrap",
            // borderRadius: "0px 0px 7px 7px",
          }}
        >
          Best viewed on Google Chrome
        </span>
      )}
    </div>
  );
};

export default BrowserCheck;
